import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Lane chrome — a colored band under the header plus, on the business lane, a
 * faint diagonal watermark behind the page. It is the visual cue that stops a
 * real payroll entry landing in the demo workspace.
 *
 * CSS only: nothing here reaches a generated PDF, so pay stubs and filings are
 * unaffected.
 */
export default function LaneChrome() {
  const [lane, setLane] = useState(null);

  useEffect(() => {
    api.get("/workspaces").then(({ data }) => setLane(data.active)).catch(() => setLane(null));
  }, []);

  if (!lane?.lane) return null;

  return (
    <>
      <div data-testid="lane-band"
           className="w-full px-4 py-1.5 flex items-center justify-center gap-3 font-mono text-[10px] uppercase tracking-[0.2em]"
           style={{ background: lane.color, color: lane.on_color }}>
        <span className="w-1.5 h-1.5 rounded-full" style={{ background: lane.on_color }} />
        <span data-testid="lane-band-label">{lane.label}</span>
        <span className="opacity-70 hidden sm:inline" data-testid="lane-band-sub">{lane.sublabel}</span>
      </div>
      {lane.watermark && (
        <div data-testid="lane-watermark" aria-hidden="true"
             className="pointer-events-none fixed inset-0 z-0 overflow-hidden select-none flex items-center justify-center">
          <span className="font-heading font-black whitespace-nowrap"
                style={{ transform: "rotate(-24deg)", fontSize: "13vw",
                         color: lane.color, opacity: 0.045, letterSpacing: "0.05em" }}>
            {lane.watermark}
          </span>
        </div>
      )}
    </>
  );
}
